export interface Apis {
  batchInsertControlCabinetConfig: string;
  selectControlCabinetConfigById: string;
}
export const apis: Apis = {
  batchInsertControlCabinetConfig: '/iparkAdmin/controlcabinet/batchInsertControlCabinetConfig',
  selectControlCabinetConfigById: '/iparkAdmin/controlcabinet/selectControlCabinetConfigById'
}
